import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadproductwisereportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/leadproductwisereport";

  searchLeadProductWiseReport(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  downloadLeadProductWiseReport(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getLeadProductWiseReport(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
